<template>
  <div ref="pieChartContainer" style="width: 100%; height: 200px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'PieChart',
  props: {
    data: {
      type: Array,
      required: true,
      // пример: [{ name: 'Отдых', value: 120 }, { name: 'Работа', value: 300 }]
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chart) this.chart.dispose();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.pieChartContainer);

      const total = this.data.reduce((sum, item) => sum + item.value, 0);
      // пересчёт в проценты
      const percentData = this.data.map(item => ({
        name: item.name,
        value: ((item.value / total) * 100).toFixed(2)
      }));

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            data: percentData,
            emphasis: {
              scale: true,
              scaleSize: 8
            }
          }
        ]
      };

      this.chart.setOption(option);

      // обработчик наведения
      this.chart.on('mouseover', params => {
        this.updateCenterText(params.data);
      });

      this.chart.on('mouseout', () => {
        this.resetCenterText();
      });

      // текст по центру по умолчанию
      this.resetCenterText();
    },

    updateCenterText(data) {
      this.chart.setOption({
        graphic: [
          {
            type: 'group',
            left: 'center',
            top: 'center',
            children: [
              // {
              //   type: 'text',
              //   top: -15,
              //   style: {
              //     text: data.name,
              //     textAlign: 'center',
              //     fill: '#333',
              //     fontSize: 18,
              //     fontWeight: 'bold'
              //   }
              // },
              // {
              //   type: 'text',
              //   top: 10,
              //   style: {
              //     text: `${data.value}%`,
              //     textAlign: 'center',
              //     fill: '#666',
              //     fontSize: 14
              //   }
              // }
            ]
          }
        ]
      });
    },

    resetCenterText() {
      // this.chart.setOption({
      //   graphic: [
      //     {
      //       type: 'group',
      //       left: 'center',
      //       top: 'center',
      //       children: [
      //         {
      //           type: 'text',
      //           left: 'center',
      //           top: 'center',
      //           style: {
      //             text: 'Наведи на сектор',
      //             textAlign: 'center',
      //             fill: '#999',
      //             fontSize: 16
      //           }
      //         }
      //       ]
      //     }
      //   ]
      // });
    },

    resizeChart() {
      if (this.chart) this.chart.resize();
    }
  }
};
</script>
